import React, { Component } from 'react';

class NoMatch extends Component {

  constructor(props) {
    super(props);
    
    console.log( this.props.location.pathname );
  }
    render() {
        return (
            <div className="notfound">
                <h1>Page Not Found</h1>
                <p>Sorry, but the page you were trying to view does not exist.</p>
            </div>
        );
    }
}

export default NoMatch;






// WEBPACK FOOTER //
// ./src/pages/nomatch/index.js